import React from 'react';
import { Alert as ReactAlert, Spinner as ReactSpinner, Button as ReactButton } from '@a-ui/react';
import { translate } from '../../i18n';
import emptyArrays from '../../util/emptyArrays';
import ConfirmationModal from '../ConfirmationModal';
import DataList from '../DataList';
import Form, { FormErrors } from '../Form';
import { FormHelpers, FormProps } from '../Form/Form';
import Typography from '../Typography';

interface DataFormProps {
  onSubmit: FormProps['onSubmit'];
  validationSchema: FormProps['validationSchema'];
  initialValues: FormProps['initialValues'];
  domain?: Api.Domain;
  data?: Record<string, string | number>;
  loading?: boolean;
}

const DataForm: React.FC<DataFormProps> = ({
  data,
  onSubmit,
  validationSchema,
  children,
  initialValues,
  loading: isLoading,
  domain,
}) => {
  const [isEditing, setEditing] = React.useState<boolean>(false);
  const [isModalVisible, setModalVisible] = React.useState<boolean>(false);

  const toggleForm = () => {
    setEditing(!isEditing);
    setModalVisible(false);
  };

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  const handleSubmit = (values: any, helpers: FormHelpers) => {
    onSubmit(values, helpers);
    setEditing(false);
    setModalVisible(false);
  };
  return (
    <>
      {!isEditing && (
        <>
          {isLoading ? (
            <div>
              <ReactSpinner size="medium" />
            </div>
          ) : (
            <>
              {domain && emptyArrays(Object.values(initialValues)) && (
                <div className="u-margin-bottom">
                  <ReactAlert>
                    <Typography>
                      {translate('data.form.no_data', { domain: domain.name })}
                    </Typography>
                  </ReactAlert>
                </div>
              )}
              <DataList data={data} />
            </>
          )}
          <div className="u-margin-top">
            <ReactButton onClick={toggleForm}>{translate('common.button.edit')}</ReactButton>
          </div>
        </>
      )}

      {isEditing && (
        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <div className="u-margin-bottom">
            <ReactAlert inline>
              <Typography>{translate('data.form.save')}</Typography>
            </ReactAlert>
          </div>

          <FormErrors />

          {children}

          <div className="ckp-m-data-form__buttons">
            <ReactButton htmlType="submit">{translate('common.button.save')}</ReactButton>
            <ReactButton htmlType="button" onClick={toggleModal}>
              {translate('common.button.cancel')}
            </ReactButton>
          </div>
        </Form>
      )}

      <ConfirmationModal
        title="data.form.modal.title"
        body="data.form.modal.description"
        confirmLabel="common.modal.confirm"
        cancelLabel="common.modal.cancel"
        onRequestClose={toggleModal}
        onConfirm={toggleForm}
        isOpen={isModalVisible}
      />
    </>
  );
};

export default DataForm;
